<template>
  <GamePageLayout
    :banner-props="bannerProps"
    :background="background"
    :all-init-done="allInitDone"
    :show-search="false"
    :show-notifications="false"
    @banner-loaded="completeInit"
    class="records-page"
  >
    <!-- Main records content -->
    <template #content>
      <div class="records-container">
        <!-- Inner content section with background -->
        <section 
          class="inner-content"
          :style="{ 'background-image': `url(${contentBg})` }"
        >
          <!-- Discovery statistics -->
          <RecordsStats 
            :stats="discoveryStats"
            class="records-stats"
          />
          
          <!-- Discovery list -->
          <DiscoveryList 
            :discoveries="discoveries"
            :filtered-discoveries="filteredDiscoveries"
            :discovery-types="discoveryTypes"
            :selected-type="selectedType"
            @type-selected="setSelectedType"
            @discovery-clicked="handleDiscoveryClick"
          />
        </section>
      </div>
    </template>
  </GamePageLayout>
</template>

<script>
import GamePageLayout from '../../components/GamePageLayout.vue';
import DiscoveryList from './components/DiscoveryList.vue';
import RecordsStats from './components/RecordsStats.vue';
import { useRecords } from '../../composables/useRecords';

/**
 * Refactored Records page following SOLID principles
 * Single Responsibility: Orchestrates records page components and state
 * Open/Closed Principle: Extensible through composition and props
 * Dependency Inversion: Depends on composables and child components
 */
export default {
  name: 'RecordsPage',
  
  components: {
    GamePageLayout,
    DiscoveryList,
    RecordsStats
  },
  
  props: [
    'memberLineId', 
    'memberName', 
    'groupId', 
    'updateGroupStoryShip', 
    'updateFinishedDemo'
  ],
  
  setup(props) {
    // Use the records composable for all business logic
    const recordsState = useRecords(props);
    
    /**
     * Handle discovery item click (for future expansion)
     * @param {Object} discovery - Discovery object
     */
    const handleDiscoveryClick = (discovery) => {
      // Could be used for showing detailed view or other interactions
      console.log('Discovery clicked:', discovery);
    };
    
    // Return all the reactive state and methods
    // This component now has a single responsibility: orchestrating the UI
    return {
      ...recordsState,
      handleDiscoveryClick
    };
  }
};
</script>

<style lang="scss" scoped>
.records-page {
  .records-container {
    min-height: calc(100vh - 150px);
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    
    .inner-content {
      width: 100%;
      max-width: 600px;
      min-height: 400px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      padding: 32px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      // Ensure content doesn't overflow
      overflow: hidden;
    }
  }
  
  .records-stats {
    margin-bottom: 0.15rem;
  }
}

// Responsive design
@media (max-width: 768px) {
  .records-page {
    .records-container {
      padding: 10px;
      
      .inner-content {
        padding: 20px;
        max-width: 100%;
      }
    }
  }
}

// Loading state
.records-container {
  &.loading {
    opacity: 0.7;
    pointer-events: none;
  }
}
</style>